// extracted by mini-css-extract-plugin
module.exports = {"splash":"Splash_splash__2j2be global_content-wrapper__39Djl"};